












import { Vue, Component } from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
import SearchForm from '@/components/period/member/SearchForm.vue';
import ContentWrap from '@/components/period/member/ContentWrap.vue';

@Component({
  components: {
    SearchForm,
    ContentWrap,
  },
  directives: {
    ClickOutside,
  },
})
export default class PeriodInfo extends Vue {
  private changeQuery() {
    (this.$refs.searchForm as SearchForm).onSearch();
  }
}
